import { connect } from 'react-redux';
import View from './CollapseButtonView';
import { isCollapsedWithButtonSelector } from '../ContextualSidebarSelector';
import { setIsCollapsed } from '../ContextualSidebarActions';

const mapStateToProps = (state, ownProps) => ({
  isCollapsed: isCollapsedWithButtonSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onExpand: () => {
    dispatch(setIsCollapsed(false));
  },
  onCollapse: () => {
    dispatch(setIsCollapsed(true));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
